import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  FindMerchantCommunitiesFromOffersQuery,
  Community
} from "../../../../schemaTypes";
import { newOfferSubscription } from "../../../Offer/FindOffers";

export const findMerchantCommunitiesFromOffersQuery = gql`
  query FindMerchantCommunitiesFromOffers {
    findMerchantCommunitiesFromOffers {
      id
      name
      alias
      logoUrl
      colorCode
      createdAt
      updatedAt
    }
  }
`;

newOfferSubscription;

type NewOfferSubscriptionResult = {
  newOffer: Community;
};

export function useSubscribeToNewOffers(subscribeToMore: any) {
  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newOfferSubscription,
      updateQuery: (prev: any, { subscriptionData }: { subscriptionData: { data?: NewOfferSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findMerchantCommunitiesFromOffers: [
            ...prev.findMerchantCommunitiesFromOffers,
            subscriptionData.data.newOffer
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);
}

export function useFindMerchantCommunitiesFromOffers({ skip = false }: { skip?: boolean } = {}) {
  const { data, loading, subscribeToMore } = useQuery<FindMerchantCommunitiesFromOffersQuery>(findMerchantCommunitiesFromOffersQuery, { skip });

  useSubscribeToNewOffers(skip ? null : subscribeToMore);

  return {
    communities: data?.findMerchantCommunitiesFromOffers ?? [],
    loading
  };
}
